var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21851",
    "data-name": "\\uADF8\\uB8F9 21851",
    transform: "translate(-872 -639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21264",
    "data-name": "\\uADF8\\uB8F9 21264",
    transform: "translate(-570 670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9838",
    "data-name": "\\uD328\\uC2A4 9838",
    d: "M0,0H24V24H0Z",
    transform: "translate(1442 -31)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21848",
    "data-name": "\\uADF8\\uB8F9 21848",
    transform: "translate(140.844 -57.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10305",
    "data-name": "\\uD328\\uC2A4 10305",
    d: "M6.61,116.064v8.213a.713.713,0,0,0,.716.711h3.434a.535.535,0,0,0,.537-.533v-4.5a1.167,1.167,0,0,1,1.172-1.162h3.386a1.167,1.167,0,0,1,1.172,1.162v4.537a.5.5,0,0,0,.5.5h3.516a.664.664,0,0,0,.667-.662v-8.262",
    transform: "translate(728.994 593.235)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10306",
    "data-name": "\\uD328\\uC2A4 10306",
    d: "M21.313,102.889l-9.9-8.784L1,102.889",
    transform: "translate(732 605)",
    fill: "#fff",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.14b9541e7550b2fd17d975b140b5cb7b.svg";
export { ForwardRef as ReactComponent };